import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { EventIndexModel } from '../../../../core/models/event-index.model';
import { tap } from 'rxjs/operators';
import { NoteColumnsEnum } from '../../../../core/state-mangement/entities/note-items/note-columns.enum';
import { Sort } from '@angular/material/sort';
import { MaterialCatalogueListItem } from 'src/app/core/models/client-models';

@Component({
  selector: 'app-material-catalog-list-table',
  templateUrl: './material-catalog-list-table.component.html',
  styleUrls: ['./material-catalog-list-table.component.scss'],
})
export class MaterialCatalogListTableComponent implements OnInit {
  @Input() materialCatalogueList$: Observable<MaterialCatalogueListItem[]>;
  @Input() tableColumns$: Observable<any>;
  @Input() selectedIndex$: Observable<number>;
  @Output() onClickEvent = new EventEmitter<MaterialCatalogueListItem>();
  @Output() onHoverEvent = new EventEmitter<number>();
  @Output() sortEvent = new EventEmitter<Sort>();

  dataSource: MatTableDataSource<MaterialCatalogueListItem>;
  onResize$ = new Subject<EventIndexModel>();
  columns = NoteColumnsEnum;
  displayedColumns: string[] = [];

  private subscriptions = new Subscription();

  constructor() {}

  ngOnInit() {
    this.subscriptions.add(
      this.materialCatalogueList$.subscribe((value) => {
        this.dataSource = new MatTableDataSource<MaterialCatalogueListItem>(
          value
        );
      })
    );
    this.registerColumns();
  }

  onColumnResize(event, column) {
    const index = this.displayedColumns.findIndex(
      (element) => element == column
    );
    this.onResize$.next({
      event,
      index,
    } as EventIndexModel);
  }

  onClick(row: MaterialCatalogueListItem) {
    this.onClickEvent.next(row);
  }

  onSort(event: Sort) {
    this.sortEvent.emit(event);
  }

  onHover(index: number) {
    this.onHoverEvent.emit(index);
  }

  private registerColumns() {
    this.subscriptions.add(
      this.tableColumns$
        .pipe(
          tap((columns) => {
            this.displayedColumns = [];
            columns.forEach((column) => {
              if (column.selected) {
                this.displayedColumns.push(column.name);
              }
            });
          })
        )
        .subscribe()
    );
  }
}
